import React from 'react';
import {
  CategoryCarousel,
  CategoryCarouselProps,
  CategoryCarouselPropsCard,
  Control,
} from '@noths/polaris-client-ribbons-design-system';

import { CategoryCarouselCategorySerializedData } from '../../../content/blocks/categoryCarousel/types';
import { trackCarouselNavigation } from '../../../tracking/common/carousel';
import { trackItemsImpression } from '../../../tracking/common/trackItemsImpression';
import { trackLinkClick } from '../../../tracking/common/trackLinkClick';
import { TrackingContext } from '../../../types/TrackingContext';
import { setFeaturedProductParamOnURL } from '../../../utils/setFeaturedProductParamOnURL';
import { BlockContainer } from '../BlockContainer/BlockContainer';
import * as styles from './CategoryCarouselBlock.style';

export interface CategoryCarouselBlockProps extends Omit<CategoryCarouselProps, 'categories'> {
  trackingTitle: string;
  trackingPosition?: number;
  categories: CategoryCarouselCategorySerializedData[];
}

export const CategoryCarouselBlock = ({
  trackingTitle,
  trackingPosition,
  categories,
  title,
}: CategoryCarouselBlockProps) => {
  const trackingContext: TrackingContext = {
    trackingPosition,
    trackingTitle,
    trackingContentType: 'Category carousel',
  };

  return (
    <BlockContainer wrapperStyles={styles.wrapper} maxWidth="max" columnsXL={10}>
      <CategoryCarousel
        title={title}
        categories={categories}
        onVisible={() => {
          if (categories.length > 0) {
            trackItemsImpression({
              ...trackingContext,
              numberOfItems: categories.length,
            });
          }
        }}
        onCategoryClick={(e, { index }) => {
          const { categoryName, productCode } = categories[index];

          e.currentTarget.href = setFeaturedProductParamOnURL(e.currentTarget.href, productCode);

          trackLinkClick(e, {
            ...trackingContext,
            link: {
              index,
              name: categoryName,
              href: e.currentTarget.href,
            },
            numberOfItems: categories.length,
            actionName: 'Category click',
          });
        }}
        onNavigation={(swiped: boolean, control: Control) => {
          const direction = control === 'next' ? 'next' : 'previous';

          trackCarouselNavigation(swiped, direction, {
            ...trackingContext,
            numberOfItems: categories.length,
          });
        }}
      />
    </BlockContainer>
  );
};

export type { CategoryCarouselProps, Control, CategoryCarouselPropsCard };
